import * as React from "react";
import clsx from "clsx";
import { useRouter } from "next/router";
import Num2persian from "num2persian";
import { useDispatch, useSelector } from "react-redux";

import {
  Dialog,
  Slide,
  Grid,
  Typography,
  IconButton,
  makeStyles,
  Container,
  Button,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { newConvertPersianDigitsToEnglish } from "../../../../../../helpers/validators";
import { me } from "../../../../../../redux/slices/me";
import {
  changeIntentId,
  openNewFastPay,
  setLogin,
  setOpenNewFastPay,
} from "../../../../../../redux/slices/publicSlice";
import RoundButton from "../../../../../common/button/RoundButton";
import RoundedSelectBox from "../../../../../common/selectBox/RoundedSelectBox";
import RoundedTextField from "../../../../../common/textfield/RoundedTextField";

import CurrencyFormat from "../../../../../../services/CurrencyFormat";
import WalletUseingComponent from "../../../../../common/walletUseingComponent/WalletUseingComponent";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      margin: "0 !important",
      borderRadius: "21px",
    },
    "& .MuiDialog-paperFullWidth": {
      width: "90%",
      borderRadius: "21px",
      maxWidth: 400,
    },
  },
  closeIcon: {
    fontSize: "1.818rem",
  },
  container: {
    width: "100%",
    borderRadius: "21px",
    border: "1px solid #dadada",
  },
  real__root: {
    height: "100%",
    paddingBottom: 20,
  },
  padding: {
    padding: "10px 0",
  },
  row: {
    backgroundColor: "#ffffff",
    "& *": {
      fontSize: "2.181rem",
    },
  },
  closeRow: {
    height: "50px",
    backgroundColor: "#ffffff",
    borderRadius: "21px 21px 0 0",
  },
  subjectSelector: {
    marginTop: "15px",
    marginBottom: "5px",
  },

  itemContainer: {
    padding: "0 20px",
  },
  priceBtn: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "20px",

    border: `1px solid ${theme.palette.landing.light}`,
    padding: "0 5px !important",
    height: "30px !important",
    "&:hover": {
      transform: "none",
    },
    "& *": {
      color: theme.palette.landing.light,
    },
  },
  currency: {
    fontSize: "1.181rem !important",
  },
  donateValue: {
    fontSize: "14px !important",
    width: "100%",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: "12px !important",
    },
  },
  activeTab: {
    backgroundColor: theme.palette.landing.main,
    "& *": {
      color: "white",
    },
    "&:hover": {
      backgroundColor: theme.palette.landing.main,
    },
  },
  itemContainer: {
    padding: "0",
  },
  align: {
    color: "#ff1339",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "14px",
    marginTop: 5,
  },
}));

const numbers = /^(|[0-9]\d*)$/;

const NewInstantPaymentDialog = () => {
  // const DEFAULT_VALUES = [50000, 100000, 200000, othersValue];
  const DEFAULT_VALUES = [
    { value: 50000, label: "50 هزار تومان" },
    { value: 100000, label: "100 هزار تومان" },
    { value: 200000, label: "200 هزار تومان" },
  ];

  const classes = useStyles();
  const history = useRouter();
  const dispatch = useDispatch();
  const [paymentValue, setPaymentValue] = React.useState(50000);

  const [intent, setIntent] = React.useState(0);

  const categoryDialogStatus = useSelector(
    (state) => state.home.openCategories
  );

  const open = useSelector(openNewFastPay);

  const setOpen = (b) => {
    dispatch(setOpenNewFastPay(b));
  };

  React.useEffect(() => {
    if (categoryDialogStatus === true) {
      setOpen(false);
      history.replace("/");
    }
  }, [categoryDialogStatus, setOpen]);

  const handleClose = () => {
    history.replace("/");
    setOpen(false);
  };

  const user = useSelector(me);

  const handleIntentChange = (value) => {
    setIntent(value);
  };

  const handleBtnClicked = (e) => {
    setPaymentValue(e);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      scroll="paper"
      fullWidth
      onClose={handleClose}
      className={classes.root}
    >
      <Grid container className={classes.container}>
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={12}
          justifyContent="flex-start"
          className={classes.closeRow}
        >
          <IconButton onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </Grid>
        <Container className={classes.real__root}>
          <Grid item xs={12} sm={12} className={classes.padding}>
            <Grid container>
              {DEFAULT_VALUES.map((item) => (
                <Grid item xs={4} style={{ padding: 5 }} key={item.value}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => handleBtnClicked(item.value)}
                    className={clsx(
                      classes.priceBtn,
                      paymentValue === item.value && classes.activeTab
                    )}
                  >
                    <Typography variant="h5" className={classes.donateValue}>
                      {item.label}
                    </Typography>
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <RoundedTextField
              name="paymentValue"
              placeholder="مبلغ دلخواه"
              onChange={(e) => {
                const text = e.target.value.replaceAll(",", "");
                const en = newConvertPersianDigitsToEnglish(text);
                if (numbers.test(en)) {
                  setPaymentValue(en);
                }
              }}
              value={CurrencyFormat(paymentValue)}
            />

            <Typography variant="h5" className={classes.align}>
              {Num2persian(paymentValue)} تومان
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.padding}>
            <WalletUseingComponent
              amount={+paymentValue || 0}
              wallet={user?.wallet?.balance || 0}
              paymentURL="immediate-payments"
              paymentData={{
                amount: Number(paymentValue) * 10,
                ...(intent !== null && intent > 0
                  ? { intent_id: intent.toString() }
                  : null),
              }}
              text="حمایت میکنم"
            />
          </Grid>

          <Grid
            item
            container
            md={12}
            className={clsx(classes.itemContainer, classes.subjectSelector)}
          >
            {/* <RoundedSelectBox items={axes} extraHandler={handleIntentChange} /> */}
            <RoundedSelectBox
              defaultValue={0}
              items={[
                { id: 0, name: "نیت را انتخاب کنید" },
                { id: 277332, name: "آموزش" },
                { id: 277333, name: "بهداشت و درمان" },
                { id: 277334, name: "فرهنگی و هنری" },
                { id: 277335, name: "معیشتی" },
                { id: 277336, name: "کارآفرینی و اشتغال" },
                { id: 277338, name: "کمک نقدی" },
                { id: 277337, name: "ازدواج" },
              ]}
              extraHandler={handleIntentChange}
            />
          </Grid>
        </Container>
      </Grid>
    </Dialog>
  );
};

export default NewInstantPaymentDialog;
